<template>
    <div class="progress-bar-wrpr">
	    <div class="progress-bar"
	         :style="style"
	         :class="['pb-'+labelPosition, pbStyle, pbStatic, advanced.cssClasses ? advanced.cssClasses : '']"
	         :id="advanced.cssId ? advanced.cssId : ''">
		    <div class="pb-inner" style="">
			    <span class="pb-number">{{ basic.labelText || '60%' }}</span>
			    <div class="pb-fill"
			         :style="{width: basic.valueNumber ? (basic.valueNumber.number + '%') : '60%',
                    backgroundColor: basic.progressColor1 ? basic.progressColor1 : null,
                    backgroundImage: backgroundImage}"></div>
		    </div>
	    </div>
    </div>
</template>

<script>
import {borderProps, boxShadow, getPadding, textDecoration, textShadow} from "@/modules/page-editor/src/utils/props";

export default {
    name: 'EmailProgressBar',
    props: ['details'],
    computed: {
        basic() {
            return this.details.attributes.basic
        },
        advanced() {
            return this.details.attributes.advanced
        },
        responsive() {
            return this.details.responsive
        },
        responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
	    backgroundImage() {
		    if (!this.basic.progressColor1 && !this.basic.progressColor2) return null;
		    let c1 = this.basic.progressColor1 || 'rgb(43, 194, 83)';
		    let c2 = this.basic.progressColor2 || 'rgb(84, 240, 84)';

		    return `linear-gradient(${c1} 37%, ${c2} 69%)`;
	    },
	    labelPosition() {
		    return (this.basic.labelPosition ? this.basic.labelPosition : 'center')
	    },
	    pbStyle() {
		    return (this.basic.style==='simple' ? 'pb-simple' : '')
	    },
	    pbStatic() {
		    return (!this.basic.animated || !this.basic.animated.booleanValue ? 'pb-static' : '')
	    },
        style() {
	        let {borderTop,
		        borderLeft,
		        borderRight,
		        borderBottom, borderRadius,borderColor} = borderProps(this.advanced.border);

            let fontFamily = this.advanced.font ? this.advanced.font.fontFamily : null;
            let fontSize = this.advanced.font ? this.advanced.font.fontSize : null;
            let fontStyling = this.advanced.font ? this.advanced.font.fontStyling : null;
	        let color = this.basic.font ? this.basic.font.color : null;

            var transform = this.advanced.transformation ?
                'rotateX('+ this.advanced.transformation.rotateX +'deg) ' +
                'rotateY('+ this.advanced.transformation.rotateY +'deg) ' +
                'rotateZ('+ this.advanced.transformation.rotateZ +'deg) ' +
                'scale3d('+this.advanced.transformation.scaleX+', '+this.advanced.transformation.scaleY+', '+this.advanced.transformation.scaleZ+')' : false;

            var transition = this.advanced.animations ?
                this.advanced.animations.duration + 's ' +
                this.advanced.animations.property + ' ' +
                this.advanced.animations.easing : 'initial';

            var height = this.basic.height ? this.basic.height.number + 'px' : '17px';

            return {
                margin: getPadding(this.basic.margin),
                padding: getPadding(this.basic.padding),
	            borderTop,
	            borderLeft,
	            borderRight,
	            borderBottom,
	            borderRadius,
	            borderColor,
	            color,
              fontFamily,
              fontSize,
              fontWeight: fontStyling&&fontStyling.bold ? 'bold' : null,
              fontStyle: fontStyling&&fontStyling.italic ? 'italic' : null,
              textDecoration: textDecoration(this.basic.font),
              backgroundColor: this.basic.backgroundColor,
              boxShadow: boxShadow(this.basic.shadows),
              textShadow: textShadow(this.advanced.textShadows),
              transform,
              transition,
              height
            };
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>
